var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "config-module": "2500",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "CargoMsg.Cargo_QueryTip"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "flex" },
                      attrs: { "label-position": "left" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "look",
                                disabled: !_vm.selectData,
                                type: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toLook()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                          ),
                          _vm.$checkPermission(["button_cabinManagement_edit"])
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "edit",
                                    disabled: !_vm.selectData,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toEdit()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.btn.edit")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_cabinManagement_importOfCabinSpace"
                          ]) ||
                          _vm.$checkPermission(["button_cabinManagement_add"])
                            ? _c(
                                "el-dropdown",
                                {
                                  staticStyle: { margin: "0 5px" },
                                  attrs: {
                                    no: "exportOrderHandle",
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.exportOrderHandle()
                                    },
                                    command: function(p) {
                                      _vm.exportOrderCommand = p
                                      _vm.exportOrderHandle()
                                    }
                                  }
                                },
                                [
                                  _vm.exportOrderCommand ===
                                    _vm.$t(
                                      "CargoMsg.Cargo_DownImportTemplate"
                                    ) &&
                                  _vm.$checkPermission([
                                    "button_cabinManagement_importOfCabinSpace"
                                  ])
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DownImportTemplate"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm.exportOrderCommand !==
                                      _vm.$t("CargoMsg.Cargo_Import2")
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.exportOrderCommand))
                                      ])
                                    : _vm._e(),
                                  _vm.exportOrderCommand ===
                                  _vm.$t("CargoMsg.Cargo_Import2")
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            "margin-left": "5px"
                                          },
                                          attrs: {
                                            action:
                                              _vm.URL.booking.cabinManagement
                                                .importTemplate,
                                            headers: _vm.headers,
                                            "show-file-list": false,
                                            accept: ".xls, .xlsx",
                                            "before-upload":
                                              _vm.beforeOrderUpload,
                                            "on-success":
                                              _vm.uploadOrderSuccess,
                                            "on-error": _vm.handleError,
                                            data: {
                                              branchId:
                                                _vm.$store.getters
                                                  .currentOfficeId,
                                              lob: "SE"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticStyle: { color: "white" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Import2"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _vm.$checkPermission([
                                        "button_cabinManagement_add"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "CargoMsg.Cargo_NewTo"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_NewTo"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_importOfCabinSpace"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "CargoMsg.Cargo_Import2"
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "el-upload",
                                                {
                                                  ref: "uploadOrder",
                                                  staticStyle: {
                                                    display: "inline-block"
                                                  },
                                                  attrs: {
                                                    action:
                                                      _vm.URL.booking
                                                        .cabinManagement
                                                        .importTemplate,
                                                    headers: _vm.headers,
                                                    "show-file-list": false,
                                                    accept: ".xls, .xlsx",
                                                    "before-upload":
                                                      _vm.beforeOrderUpload,
                                                    "on-success":
                                                      _vm.uploadOrderSuccess,
                                                    "on-error": _vm.handleError,
                                                    data: {
                                                      branchId:
                                                        _vm.$store.getters
                                                          .currentOfficeId
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticStyle: {
                                                        "padding-left": "0px",
                                                        color: "#6F6F6F",
                                                        "text-align": "left",
                                                        width: "80px"
                                                      },
                                                      attrs: {
                                                        slot: "trigger",
                                                        type: "text"
                                                      },
                                                      slot: "trigger"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Import2"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_importOfCabinSpace"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: {
                                                command: _vm.$t(
                                                  "CargoMsg.Cargo_DownImportTemplate"
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_DownImportTemplate"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "Clone", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toClone()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")) + " ")]
                          ),
                          _vm.$checkPermission([
                            "button_cabinManagement_cabinSpaceBackFill"
                          ]) ||
                          _vm.$checkPermission([
                            "button_cabinManagement_revokeAllocation"
                          ]) ||
                          _vm.$checkPermission([
                            "button_cabinManagement_cabinReturn"
                          ])
                            ? _c(
                                "el-dropdown",
                                {
                                  staticStyle: {
                                    "padding-left": "5px",
                                    "font-size": "12px"
                                  },
                                  attrs: { no: "batchHandle" },
                                  on: { command: _vm.batchHandle }
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_BatchProcessing"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _vm.$checkPermission([
                                        "button_cabinManagement_cabinSpaceBackFill"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 1 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_CabinSpaceBackFill"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_revokeAllocation"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 2 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_RevokeAllocation"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_cabinReturn"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 3 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_CancelCabinReservation"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_batchVessel"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 4 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.BatchVessel"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_cabinManagement_AllocateSEBooking"
                          ]) ||
                          _vm.$checkPermission([
                            "button_cabinManagement_AllocateVerify"
                          ]) ||
                          _vm.$checkPermission([
                            "button_cabinManagement_AllocateCreateSEBooking"
                          ]) ||
                          _vm.$checkPermission([
                            "button_cabinManagement_AllocateCreateVerify"
                          ])
                            ? _c(
                                "el-dropdown",
                                {
                                  staticStyle: {
                                    "padding-left": "5px",
                                    "font-size": "12px"
                                  },
                                  attrs: { no: "allocationHandle" },
                                  on: { command: _vm.allocationHandle }
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_AllocateCabinSpace"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _vm.$checkPermission([
                                        "button_cabinManagement_AllocateSEBooking"
                                      ]) ||
                                      _vm.$checkPermission([
                                        "button_cabinManagement_AllocateVerify"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 1 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Allocate1"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$checkPermission([
                                        "button_cabinManagement_AllocateCreateSEBooking"
                                      ]) ||
                                      _vm.$checkPermission([
                                        "button_cabinManagement_AllocateCreateVerify"
                                      ])
                                        ? _c(
                                            "el-dropdown-item",
                                            { attrs: { command: 2 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Allocate2"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_cabinManagement_returnRecovery"
                          ])
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { margin: "0 5px" },
                                  attrs: {
                                    no: "returnRecovery",
                                    type: "primary"
                                  },
                                  on: { click: _vm.handleShutOut }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ShutOut2")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_cabinManagement_deleteCabin"
                          ])
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { margin: "0 5px" },
                                  attrs: { no: "deleteCabin", type: "danger" },
                                  on: { click: _vm.deleteCabinHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Delete")) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "padding-left": "10px" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "1" },
                                  on: { change: _vm.toQuery },
                                  model: {
                                    value: _vm.listType,
                                    callback: function($$v) {
                                      _vm.listType = $$v
                                    },
                                    expression: "listType"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_DisplayByBillOfLading"
                                        )
                                      )
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_DisplayByDateAndVoyageNo"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.$checkPermission([
                        "button_cabinManagement_viewSeaexportJob"
                      ])
                        ? _c(
                            "div",
                            {
                              staticClass: "custom-checkbox",
                              staticStyle: { "padding-left": "30px" }
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { no: "showSeaExportJob" },
                                      model: {
                                        value: _vm.showSeaExportJob,
                                        callback: function($$v) {
                                          _vm.showSeaExportJob = $$v
                                        },
                                        expression: "showSeaExportJob"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_ShowSeaExportJob"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "custom-checkbox",
                          style: {
                            paddingLeft: "30px",
                            minWidth: _vm.$selectByLang(
                              "400px",
                              "400px",
                              "400px",
                              "600px",
                              "600px",
                              "600px"
                            )
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 7 } }, [
                                    _c(
                                      "span",
                                      { staticStyle: { "font-size": "14px" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.DateOfDeparture2")
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 7 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              no: "5",
                                              type: "date",
                                              "picker-options":
                                                _vm.pickerOptions,
                                              clearable: "",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.businessDate[0],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.businessDate,
                                                  0,
                                                  $$v
                                                )
                                              },
                                              expression: "businessDate[0]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: { span: 1 }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "12px" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_To"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 7 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              no: "6",
                                              type: "date",
                                              clearable: "",
                                              "picker-options":
                                                _vm.pickerOptions
                                            },
                                            model: {
                                              value: _vm.businessDate[1],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.businessDate,
                                                  1,
                                                  $$v
                                                )
                                              },
                                              expression: "businessDate[1]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listType === 0,
                    expression: "listType === 0"
                  }
                ],
                attrs: {
                  "config-module": "25000522",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              }),
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listType === 1,
                    expression: "listType === 1"
                  }
                ],
                attrs: {
                  "config-module": "25000523",
                  "grid-params": _vm.treeGridParams,
                  "grid-options": _vm.treeGridOptions,
                  "column-defs": _vm.treeColumnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.treeGridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.treeGridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.treeGridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c(
                "div",
                {
                  class: "fixedBottom",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedRows.length > 0,
                          expression: "selectedRows.length > 0"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("Clearing.Selected") +
                              _vm.selectedRows.length +
                              ":" +
                              _vm.selectRowDataLabel
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "25000521",
                  total: _vm.filter.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.customsReturnRecoveryWindow.visible
        ? _c("customs-return-recovery", {
            ref: "CustomsReturnRecovery",
            attrs: {
              "source-type": _vm.customsReturnRecoveryWindow.sourceType,
              visible: _vm.customsReturnRecoveryWindow.visible,
              title: _vm.customsReturnRecoveryWindow.title,
              "cabin-data": _vm.customsReturnRecoveryWindow.cabinData
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.customsReturnRecoveryWindow,
                  "visible",
                  $event
                )
              },
              confirmSync: _vm.confirmSyncHandler,
              allocation: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.allocationCreateWindow.visible
        ? _c("allocation-create", {
            ref: "allocationCreateWindow",
            attrs: {
              visible: _vm.allocationCreateWindow.visible,
              list: _vm.allocationCreateWindow.list
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.allocationCreateWindow, "visible", $event)
              },
              confirmSync: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.cabinSpaceBackWindow.visible
        ? _c("cabin-space-back-window", {
            ref: "cabinSpaceBackWindow",
            attrs: {
              visible: _vm.cabinSpaceBackWindow.visible,
              list: _vm.cabinSpaceBackWindow.list
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cabinSpaceBackWindow, "visible", $event)
              },
              confirmSync: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.cancelCabinWindow.visible
        ? _c("cancel-cabin-window", {
            ref: "cancelCabinWindow",
            attrs: {
              visible: _vm.cancelCabinWindow.visible,
              list: _vm.cancelCabinWindow.list,
              type: _vm.cancelCabinWindow.type,
              title: _vm.cancelCabinWindow.title
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cancelCabinWindow, "visible", $event)
              },
              confirmSync: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.transshipDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.transshipDialog.visible,
                title: _vm.$t("SeaExport.BatchVessel"),
                width: "850px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transshipDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticClass: "date-blue",
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.vessel,
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Vessel,
                                  "static-options":
                                    _vm.transshipDialog.vesselList,
                                  cache: false,
                                  filterable: "",
                                  "allow-create": true,
                                  "default-value": _vm.transshipDialog.vessel
                                },
                                on: {
                                  parentCallBack: _vm.onVesselSelectionChange
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("vessel")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.vessel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "vessel", $$v)
                                    },
                                    expression: "clearCheckBox.vessel"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BookingShipCallSign")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    _vm.clearCheckBox.bookingShipCallSign
                                },
                                model: {
                                  value:
                                    _vm.transshipDialog.bookingShipCallSign,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "bookingShipCallSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transshipDialog.bookingShipCallSign"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "bookingShipCallSign"
                                      )
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.clearCheckBox.bookingShipCallSign,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "bookingShipCallSign",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "clearCheckBox.bookingShipCallSign"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "default-value":
                                _vm.transshipDialog.loadingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.transshipDialog.loadingPortCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierId,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    seaCmp: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtCarrierId || ""
                                },
                                on: {
                                  parentCallBack: _vm.onCarrierIdSelectionChange
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierId"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierId",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierId"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture2") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.transshipDialog.dfETD,
                              callback: function($$v) {
                                _vm.$set(_vm.transshipDialog, "dfETD", $$v)
                              },
                              expression: "transshipDialog.dfETD"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfArrival2") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.eta,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.dfETA,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "dfETA", $$v)
                                  },
                                  expression: "transshipDialog.dfETA"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("eta")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.eta,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "eta", $$v)
                                    },
                                    expression: "clearCheckBox.eta"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCode") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "195px" },
                            model: {
                              value: _vm.transshipDialog.routeCode,
                              callback: function($$v) {
                                _vm.$set(_vm.transshipDialog, "routeCode", $$v)
                              },
                              expression: "transshipDialog.routeCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.DeclareCutOffDate")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.declareCutOff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.declareCutOff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "declareCutOff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.declareCutOff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "declareCutOff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.declareCutOff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "declareCutOff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.declareCutOff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierCode") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierCode
                                },
                                model: {
                                  value: _vm.transshipDialog.carrierCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "carrierCode",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.carrierCode"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierCode"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierCode",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierCode"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerClosingTime")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.clearCheckBox.customerFileCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.customerFileCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "customerFileCutoff",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "transshipDialog.customerFileCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "customerFileCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.customerFileCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "customerFileCutoff",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "clearCheckBox.customerFileCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                ref: "voyageSelect",
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.voyage,
                                  "static-options":
                                    _vm.transshipDialog.voyages || [],
                                  cache: false,
                                  "default-value": _vm.transshipDialog.voyage,
                                  filterable: "",
                                  clearable: "",
                                  "allow-create": true,
                                  "tag-name": "voyageNo",
                                  "tag-value": "voyageNo",
                                  "filter-tag-names": ["voyageNo"]
                                },
                                on: { parentCallBack: _vm.onVoyageFlightChange }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("voyage")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.voyage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "voyage", $$v)
                                    },
                                    expression: "clearCheckBox.voyage"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HarborDistrict") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.portDistrict
                                },
                                model: {
                                  value: _vm.transshipDialog.portDistrict,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "portDistrict",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.portDistrict"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "portDistrict"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.portDistrict,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "portDistrict",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.portDistrict"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("el-form-item", { attrs: { label: "IMO" } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: _vm.clearCheckBox.imo },
                              model: {
                                value: _vm.transshipDialog.imo,
                                callback: function($$v) {
                                  _vm.$set(_vm.transshipDialog, "imo", $$v)
                                },
                                expression: "transshipDialog.imo"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "10px" },
                                on: {
                                  change: function($event) {
                                    return _vm.clearCheckBoxChange("imo")
                                  }
                                },
                                model: {
                                  value: _vm.clearCheckBox.imo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.clearCheckBox, "imo", $$v)
                                  },
                                  expression: "clearCheckBox.imo"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfDischarge")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "default-value":
                                _vm.transshipDialog.dischargingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.dischargingPortCodeChange(p)
                                _vm.transshipDialog.dischargingPortCode =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.PlaceOfDelivery") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "default-value":
                                    _vm.transshipDialog.deliveryPlace
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.transshipDialog.deliveryPlace = p.value
                                  }
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "deliveryPlace"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.deliveryPlace,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "deliveryPlace",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.deliveryPlace"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.bookingAgent,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtBookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.transshipDialog.txtBookingAgent =
                                      p.cmpIdx)
                                  }
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "bookingAgent"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.bookingAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "bookingAgent",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.bookingAgent"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortAreaCYCutOffTime")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.terminalCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.terminalCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "terminalCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.terminalCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "terminalCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.terminalCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "terminalCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.terminalCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.fileCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.fileCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "fileCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.fileCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "fileCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.fileCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "fileCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.fileCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.customCutoff,
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.transshipDialog.customCutoff,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "customCutoff",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.customCutoff"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "customCutoff"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.customCutoff,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "customCutoff",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.customCutoff"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "margin-left": "20px", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Message.UpdateVoyageInfoMessage")))
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        gap: "20px",
                        "margin-top": "10px"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.op,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "op", $$v)
                                },
                                expression: "job.op"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Operation")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.csr,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "csr", $$v)
                                },
                                expression: "job.csr"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_CustomerService"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.dc,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "dc", $$v)
                                },
                                expression: "job.dc"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Documents")))]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.sales,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "sales", $$v)
                                },
                                expression: "job.sales"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Sales")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.userDefinedRoleId1,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedRoleId1", $$v)
                                },
                                expression: "job.userDefinedRoleId1"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.userDefinedRoleId2,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "userDefinedRoleId2", $$v)
                                },
                                expression: "job.userDefinedRoleId2"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.job.planer,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "planer", $$v)
                                },
                                expression: "job.planer"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_AirlinePerson"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.transShipClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.transshipDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }